import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const beautify = (str = "") =>
  (str || "").replaceAll("-", " ").replaceAll("_", " ").trim();

const capitalizar = (str = "") => str.charAt(0).toUpperCase() + str.slice(1);

const Breadcrumb = ({ lastLabel = null, aliases = {} }) => {
  const { t } = useTranslation(); // ✅
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  const baseAlias = {
    tareas: "Tareas",
    grupos: "Grupos",
    orden: "Ordenes de Compra Proveedores",
    "pedidos": "Ordenes de Compra Clientes",
    cotizacion: "Cotizaciones",
    clientes: "Clientes",
    proveedores: "Proveedores",
    usuarios: "Usuarios",
    remisiones: "Remisiones",
    personalizacion: "Personalizacion",
    "facturas-de-clientes": "Facturas Clientes",
    "facturas-de-proveedores": "Facturas Proveedores",
    categorias: "Categorías",
    generador: "Generador de Obra",
    calculador: "Calculador de Costos",
    requisiciones: "Requisiciones",
    calendario: "Calendario",
    todos: "Todos los Contactos",
    "articulos-venta": "Artículos de Venta",
    "articulos-compra": "Artículos de Compra",
    configuracion: "Configuración",
    sucursales: "Sucursales",
  };

  const alias = { ...baseAlias, ...aliases };

  const breadcrumbItems = [
    {
      label: t("breadcrumbs.home", { defaultValue: "Inicio" }),
      to: "/",
      isLink: true,
    },
  ];

  pathnames.forEach((rawSegment, index) => {
    const segment = decodeURIComponent(rawSegment);
    const pathTo = `/${pathnames.slice(0, index + 1).join("/")}`;
    const isLastSegment = index === pathnames.length - 1 && !lastLabel;

    const pretty = alias[segment] ?? capitalizar(beautify(segment));

    breadcrumbItems.push({
      label: pretty,
      to: pathTo,
      isLink: !isLastSegment,
    });
  });

  if (lastLabel) {
    breadcrumbItems.push({
      label: capitalizar(lastLabel),
      isLink: false,
    });
  }

  return (
    <nav className="breadcrumb">
      {breadcrumbItems.map((item, index) => (
        <span className="breadcrumb-item" key={index}>
          {index > 0 && <i className="bi bi-chevron-right breadcrumb-sep" />}
          {item.isLink ? (
            <Link to={item.to} className="breadcrumb-link breadcrumb-btn">
              {item.label}
            </Link>
          ) : (
            <span className="breadcrumb-current breadcrumb-badge">
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb;
